import { GuestDetails } from '../../guestDetails';
import { Media, MEDIA_STATUS } from './media';
import { sortByDateProp } from '../../../language/module';
import * as R from 'ramda';


/**
 * Returns the preferred media from the guest's media if the guest and their media exist. Otherwise returns undefined.
 * "Preferred" here means "first" because that's our preference for the time being. While a single guest could have
 * multiple media, 99.97% of them won't. So, for Phase 1 at least, we only care about their first media.
 */
export const getMostRecentMedia = (
  guest: GuestDetails | undefined,
): Media | undefined => sortByDateProp('printDate', false, R.path<Media[]>([ 'media' ], guest) || [])[ 0 ];


/**
 * Returns the preferred media from the guest's media if the guest and their media exist. Otherwise returns undefined.
 * "Preferred" here means "first" because that's our preference for the time being. While a single guest could have
 * multiple media, 99.97% of them won't. So, for Phase 1 at least, we only care about their first media.
 */
export const getPreferredMedia = (
  guest: GuestDetails | undefined,
): Media | undefined => (guest?.media || [])[0];


/**
 * Gets the guest's preferred media ID if the guest isn't undefined and if the guest's media isn't undefined and if the
 * guest's media has a Media object inside it, and if that object has a media ID. If a link in that chain breaks, you
 * get yourself an undefined. If you want to handle the case where a guest has more than one media -- this is not your
 * function.
 */
export const getPreferredMediaId = (
  guest: GuestDetails | undefined,
): string | undefined => R.path([ 'mediaID' ], getPreferredMedia(guest));



/**
 * Returns the true if the guest has active media
 */
export const hasActiveMedia = (
  guest: GuestDetails | undefined,
): boolean => (guest?.media || []).filter(m => m.statusCode === MEDIA_STATUS.active).length > 0;